export default content => !!content
